import Vue from 'vue'
import VueRouter from 'vue-router'


import Home from '../views/home.vue'
import About from '../views/about.vue'
import Proudct from '../views/proudct.vue'
import Search from '../views/search.vue'

//1 注入插件
Vue.use(VueRouter)

//2 定义路由
const routes = [
	//添加映射关系
	{
		//默认首页
		path: '/',
		redirect: '/home'
	},
	{
		path: '/home',
		component: Home
	},
	{
		path: '/about',
		component: About
	},
	{
		path: '/search',
		component: Search
	},
	{
		path: '/proudct',
		component: Proudct
	}
]

//3 创建router实例
const router = new VueRouter({
	 base: process.env.BASE_URL,
	routes
})

//4 导出router实例
export default router
